import React, { useState } from 'react';
import { Mail, RefreshCcw } from 'lucide-react';

import Integration from '../Integration';
import { DataState } from '../../context/DataProvider';

const NoMailScreen = ({
  isOutlook = true,
  noneAuthenticated,
  isGmailSynchronized,
  isOutlookSynchronized,
}) => {
  const [isSyncing, setIsSyncing] = useState(false);
  const [showIntegration, setShowIntegration] = useState(false);
  const { userGoogleId } = DataState();

  const handleSync = () => {
    setIsSyncing(true);

    // Simulate async sync operation
    setTimeout(() => {
      setIsSyncing(false);
    }, 2000); // Replace with actual sync logic
    setShowIntegration(true);
  };

  return (
    <div className="flex h-full flex-col items-center justify-center p-4 text-gray-300">
      {/* Mail Icon Box */}
      <div className="mb-6 rounded-full bg-gray-800 p-6 shadow-inner">
        <Mail className="h-10 w-10 text-gray-400" />
      </div>

      {/* Title */}
      <h2 className="mb-2 text-2xl font-bold text-white">
        {noneAuthenticated ? 'Connect your mailbox' : 'No Emails Available'}
      </h2>

      {/* Subtext */}
      {!isGmailSynchronized || !isOutlookSynchronized ? (
        <p className="mb-8 max-w-md text-center text-gray-500">
          Please sync your {isOutlook ? 'Outlook ' : 'Gmail '}
          account with our platform to start viewing your emails here.
        </p>
      ) : (
        <p className="mb-8 max-w-md text-center text-gray-500">
          Your mailbox isn’t connected yet. Please integrate your Gmail or
          Outlook account, then sync it with our platform to start viewing your
          emails here.
        </p>
      )}

      {/* Sync Button with loading */}
      <button
        disabled={isSyncing}
        onClick={handleSync}
        className={`flex items-center gap-2 rounded-lg bg-gray-700 px-5 py-2 text-sm font-medium text-white transition duration-200 ${
          isSyncing ? 'cursor-not-allowed opacity-60' : 'hover:bg-gray-600'
        }`}
      >
        <RefreshCcw className={`h-4 w-4 ${isSyncing ? 'animate-spin' : ''}`} />
        {noneAuthenticated
          ? 'Connect Mailbox'
          : isSyncing
            ? 'Syncing...'
            : 'Sync Email'}
      </button>
      {showIntegration && (
        <Integration
          onClose={() => setShowIntegration(false)}
          user_google_id={userGoogleId}
          onlyEmailApps={true}
        />
      )}
    </div>
  );
};

export default NoMailScreen;
